module.exports = __webpack_public_path__ + "static/media/drp-troubled.8cf4de62.svg";